import type { Recipe } from '../types'
import { cardImageSrc, cardImageSrcSet } from '../utils/images'

type RecipeCardProps = {
  recipe: Recipe
  onOpen: (slug: string) => void
}

export function RecipeCard({ recipe, onOpen }: RecipeCardProps) {
  return (
    <a
      className="recipe-card"
      href={`/recettes/${recipe.slug}`}
      onClick={(event) => {
        event.preventDefault()
        onOpen(recipe.slug)
      }}
    >
      <div className="recipe-card-image">
        <img
          alt=""
          height={400}
          loading="lazy"
          sizes="(max-width: 760px) 46vw, (max-width: 1020px) 31vw, 270px"
          src={cardImageSrc(recipe.image)}
          srcSet={cardImageSrcSet(recipe.image)}
          width={400}
        />
        {recipe.scaler && <span className="card-badge">Quantités ajustables</span>}
      </div>
      <div className="recipe-card-content">
        {/* R2: the card already sits inside a group titled "Salé"/"Sucré" — repeating the
            category on every card is noise. Kept on the recipe page, where it's useful. */}
        {/* C5: h4, nested under the category group's h3 — a screen reader can now tell
            this card is *within* "Salé", not a sibling heading at the same level. */}
        <h4>{recipe.title}</h4>
        <p>{recipe.description}</p>
        <span className="card-link">
          Voir la recette <span aria-hidden="true">↗</span>
        </span>
      </div>
    </a>
  )
}
